
// src/components/TabelaPaginada.js
import React from "react";

class TabelaPaginada extends React.Component {
  render() {
    const { dados, colunas, paginaAtual, totalPaginas, empresas, onPageChange } = this.props;

    return (
      <div className="table-responsive">
        <table className="table table-empresas-falidas table-hover table-bordered text-center align-middle">
          <thead className="thead-table-empresas-falidas" >
            <tr>
              {colunas.map((coluna, index) => (
                <th key={index}>{coluna.label}</th>
              ))}
            </tr>
          </thead>

       
          <tbody>
            {dados.length > 0 ? (
              dados.map((item, rowIndex) => (
                <tr key={rowIndex}>
                  {colunas.map((coluna, colIndex) => (
                    <td key={colIndex} style={{fontSize: "x-small"}}>{item[coluna.campo]}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={colunas.length} className="text-muted">
                  Nenhum registro encontrado.
                </td>
              </tr>
            )}
          </tbody>

        </table>

        {/*<span className="" style={{padding: "5px", display: "block", textAlign:"center"}}> Total de Empresas ........ :  {empresas.length} </span>*/}

        {/* Paginação */}
        <div className="d-flex justify-content-center mt-3">
          <nav>
            <ul className="pagination pagination-sm">
              <li className={`page-item ${paginaAtual === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link anterior"
                  onClick={() => onPageChange(paginaAtual - 1)}
                > 
                  <span><i className="pi pi-caret-left"></i>Anterior</span>
                  
                </button>
              </li>

              {[...Array(totalPaginas)].map((_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    paginaAtual === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => onPageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}

              <li
                className={`page-item ${
                  paginaAtual === totalPaginas ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link proximo"
                  onClick={() => onPageChange(paginaAtual + 1)}
                > 
                <span>Próximo<i className="pi pi-caret-right"></i></span>
                  
                </button>
              </li>
            </ul>
          </nav>

        </div>
      </div>
      
    );
  }
}

export default TabelaPaginada;

